import React from 'react';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { usePropertyFixFlipBudgetFile } from '../../../../queries/PropertyFileFields/NonRentalFiles';
import { formConstant } from '../constants/FormConstant';

interface BudgetFileFixFlipParameter {
    disableEditFormOptionBudget?: boolean;
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const BudgetFileFixFlip: React.FC<BudgetFileFixFlipParameter> = ({
    disableEditFormOptionBudget,
    propertyGuid,
    required,
    isReview = false,
}) => {
    const { handleMode, setHandleMode, filename: uploadFileName, setFilename: setUploadFileName, fileApiId: uploadedFileApiId, setFileApiId: setUploadedFileApiId } = usePropertyFixFlipBudgetFile(propertyGuid);

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label={formConstant.displayName.budget}
                    selector='budget'
                    formTypeName={formConstant.displayName.budget}
                    fileType={'budget'}
                    disableEditFormOption={disableEditFormOptionBudget}
                    required={required}
                    isReview={isReview}
                    propertyGuid={propertyGuid}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                />
            </div>
        </div>
    );
};
